import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { InspectorPanelMetadata } from "../../FlightPanelMetadata"
import { selectAllMergedFlightUploads, selectMergedInfraredFlightImages } from "./selectors"
import { useInspectorPanelMergedFlight } from "./useInspetorPanelMergedFlights"
import { useDownloadButtonData } from "plugins/InfraredImage/useInfraredMergedFlightDownloadButtonData"
import { InspectorPanelAccordionExport } from "../../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelAccordionIntegrations } from "../../accordion/integrations/InspectorPanelAccordionIntegrations"
import { openHotspotPanel, setHotspotPanelState, toggleList } from "panels/hotspot/slice"
import { selectMergedFlightById } from "features/entity-caching/mergedFlights/selectors"

export const InspectorPanelMergedFlightData = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectMergedFlightById(id))
    const { hotspotFlightIds = [] } = useInspectorPanelMergedFlight(flight?.id ?? "")

    const uploads = useAppSelector(selectAllMergedFlightUploads(hotspotFlightIds)) || []
    const images = useAppSelector(selectMergedInfraredFlightImages(hotspotFlightIds))
    const downloadOptions = useDownloadButtonData(images)

    const showImages = () => {
        if (!flight.hotspotFlightIds.length) return
        dispatch(
            setHotspotPanelState({
                flightId: flight.hotspotFlightIds[0],
                imageId: uploads?.at(0)?.id,
            })
        )
        dispatch(openHotspotPanel())
        dispatch(toggleList())
    }

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
                isDefaultCollapsed
            />

            {/* Integrations */}
            <InspectorPanelAccordionIntegrations
                id={id}
                integrationOptions={downloadOptions.integrationOptions}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={uploads as GenericUpload[]}
                completedUploadCount={images.length}
                onShowImagesClick={showImages}
            />
        </div>
    )
}
